module.exports = __webpack_public_path__ + "static/dusanstvo_klienti-6e7100bdd369d3c567cf0d55bbccaefb.jpg";